import { useParams } from 'react-router';

/**
 * Extracts the agency_id from the route params. Returns the value or an empty
 * string when absent.
 *
 * @returns The current agency ID from the URL.
 */
export function useAgencyId(): string {
  const { agency_id } = useParams<{ agency_id: string }>();
  return agency_id ?? '';
}
